<template>
  <div>
    <v-client-table
      :data="etatsHistoriques"
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      class="displayNoneVuePagination"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering">
      <template #creationTime = "{ row }">
        {{ func.formatDate(row.creationTime) }}
      </template>
      <template #creatorUserId = "{ row }">
        {{ getUser(row.creatorUserId) }}
      </template>
      <template #etatAvant = "{ row }">
        {{ $t(getEtatMontage(row.etatAvant)) }}
      </template>
      <template #etatApres = "{ row }">
        {{ $t(getEtatMontage(row.etatApres)) }}
      </template>
      <template #commentaire = "{ row }">
        {{ row.commentaire }}
      </template>
    </v-client-table>
  </div>
</template>

<script>

import {
  NO_PAGINATION,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { REFERENCE_TABLE_ETAT_HISTORIQUE } from '@/configuration/general/referenceTableConf';
import messageErreur from '@/services/general/messageErreur';
import getAll from '@/api/patrimoineEtatHistorique/index';
import cloneDeep from 'lodash/cloneDeep';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import formatDate from '@/services/general/formatDate';
import { ALL_ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    idPatrimoine: {
      type: String,
      required: true,
    },
    typePatrimoine: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      etatsHistoriques: [],
      referenceTable: REFERENCE_TABLE_ETAT_HISTORIQUE,
      startArrayRendering: false,
      func: {
        formatDate,
      },
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    columns() {
      return ['creationTime', 'creatorUserId', 'etatAvant', 'etatApres', 'commentaire'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      return {
        sortIcon: SORT_ICON,
        headings: {
          creationTime: this.$i18n.t('patrimoine.patrimoineEtatHistorique.tab.creationTime'),
          creatorUserId: this.$i18n.t('patrimoine.patrimoineEtatHistorique.tab.creatorUserId'),
          etatAvant: this.$i18n.t('patrimoine.patrimoineEtatHistorique.tab.etatAvant'),
          etatApres: this.$i18n.t('patrimoine.patrimoineEtatHistorique.tab.etatApres'),
          commentaire: this.$i18n.t('patrimoine.patrimoineEtatHistorique.tab.commentaire'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        sortable: ['creationTime', 'creatorUserId', 'etatAvant', 'etatApres', 'commentaire'],
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getUser(userId) {
      const userFound = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((user) => { return user.id === userId; });
      if (!userFound) return 'support@quadra-diffusion.fr';
      return nomPrenomGetter(userFound);
    },
    getEtatMontage(codeEtat) {
      const etatFind = ALL_ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const dataBody = {
        query: {
          patrimoineId: this.idPatrimoine,
          patrimoineType: this.typePatrimoine,
        },
        limit: NO_PAGINATION,
      };
      await this.loadParametreUtilisateur();
      this.etatsHistoriques = (await getAll(dataBody)).data.result.items;
      this.startArrayRendering = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
